import React, { useState } from 'react';
import './SignIn.css'
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../Config';
import { useAuth } from '../../AuthContext';


const SignIn = () => {
  const navigate = useNavigate();
  const { dispatch } = useAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
 
const handleSignIn = async(e) => {
  e.preventDefault();
  try {
    const response = await fetch(API_URL+'/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (response.status === 200) {
      const data = await response.json();
      dispatch({ type: 'SIGN_IN', payload: { user: data.username } });
      navigate('/dashboard');
      alert('Login successful!');
    } else if(response.status === 401){
      alert('Invalid credentials.');
    } else {
      alert('Login failed');
    }
  } catch (error) {
    console.error(error);
  }
}

// const handleForgetPassword = () => {
//   navigate('/ForgotPswd');
// }


  return(
    <div>
  <meta name="viewport" content="width=device-width, initial-scale=1" />
    <div className="container">
      <img src="../assets/Profile.png" alt="profile-icon" className="profile_SignIn"/>
      <h2 className="lets_Sign_you_In">LETS SIGN YOU IN</h2>
      <h4 className='welcome_back'>Welcome Back!</h4>
      <form onSubmit={handleSignIn}>
      <input type="text_SignIn" placeholder="Email, Phone or Username" name="email" value={formData.email} onChange={handleInputChange}/><br />
      <br />
      <input type="password" placeholder="Password" name="password" value={formData.password} onChange={handleInputChange} />
      <br />  
      <button className="signIn_btn" type="submit" onClick={handleSignIn} >Sign In</button>
      </form>
      {/* <div className="forgot_pswd">
        <button className="forgot_pswd_btn" onClick={handleForgetPassword}>Forgot Password?</button>
      </div>   */}
    </div> 
</div>
  )
}

export default SignIn;